import { DateTime } from "luxon";

export const formatDate = (value?: string | null): string => {
  return value
    ? DateTime.fromISO(value).toLocaleString(DateTime.DATE_MED)
    : "-";
};
